var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-bar",class:{ 'bg-primary': _vm.item.is_winner }},[(_vm.item.type == 'auction')?_c('AuctionIcon',{staticClass:"mx-2"}):(_vm.item.type == 'luckydraw')?_c('LuckyDrawIcon',{staticClass:"mx-2"}):_vm._e(),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.statusText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }